import type { DomainMapper } from '../types';

const fi: DomainMapper = {
  countryCode: 'fi',
  currency: 'EUR',
  dataAreaId: 'fi50',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/FI.svg',
  languagePrimary: true,
  locale: 'fi',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'tuote',
  sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-fi.xml',
  storyblokBasePath: 'fi',
  url: 'https://kahrs-preview.iveo.store/fi',
  algoliaIndex: 'b2b-fi-fi-FI-products',
  algoliaIndexAutocomplete: 'b2b-fi-fi-FI-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1358,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1358,
    algoliaIndex: 'b2b-fi-fi-FI-products',
    algoliaIndexAutocomplete: 'b2b-fi-fi-FI-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/tuote',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-fi.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1475,
    algoliaIndex: 'b2c-fi-fi-FI-products',
    algoliaIndexAutocomplete: 'b2c-fi-fi-FI-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'tuote',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-fi-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default fi;
